<ng-template #addContactTypeEle let-modal>
  <div class="modal-header">
	<h4 class="modal-title">Contact Type</h4>
	<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')">
	  <i class="fa fa-close"></i>
	</button>
  </div>
  <form [formGroup]="contactTypeForm" (ngSubmit)="addOrUpdateContactType()">
	<div class="modal-body text-dark">
		<div class="row" *ngIf="isProtectedContact">
			<div class="col-12 mb-3">
				<div class="alert alert-info">
					This contact role is <strong>system-defined</strong> and cannot be modified.
				</div>
			</div>
		</div>

	  <div class="row">
		<div class="col-md-6 mb-3">
		  <mat-form-field appearance="outline" class="w-100">
			<mat-label>Contact Type</mat-label>
			<input type="text" class="text-let m-0 p-0" matInput formControlName="contact_type" />
		  </mat-form-field>
		</div>
		<div class="col-md-6 mb-3">
		  <mat-form-field appearance="outline" class="w-100">
			<mat-label>Contact Role</mat-label>
			<input type="text" class="text-let m-0 p-0" matInput formControlName="contact_role" />
		  </mat-form-field>
		</div>
	  </div>
	</div>
	<div class="modal-footer text-end">
	  <button mat-stroked-button color="primary" type="submit" [disabled]="!contactTypeForm.valid">
		<mat-icon>save</mat-icon> Save
	  </button>
	</div>
  </form>
</ng-template>

<ng-template #addCustomer let-modal>
	<div class="modal-header">
		<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"><i class="fa fa-close"></i></button>
	</div>
	<div class="modal-body text-dark">
		<div class="row">

			<div class="col-12">
				<form [formGroup]="customerTypeForm">
					<mat-form-field appearance="outline">
						<mat-label>Customer Type</mat-label>
						<input type="text" class="text-let m-0 p-0" matInput formControlName="typename" />
					</mat-form-field>

					<mat-form-field appearance="outline">
						<mat-label>Address Type</mat-label>
						<mat-select formControlName="address_type">
							<mat-option [value]="'2'">Visible POS</mat-option>
							<mat-option [value]="'1'">Hide from POS</mat-option>
						</mat-select>
					</mat-form-field>

					<button mat-stroked-button color="primary" aria-label="Save" (click)="addCustomerType()" class="mt-2">
						<mat-icon>save</mat-icon> Save
					</button>
				</form>

			</div>
		</div>
	</div>

	<div class="modal-footer">
	</div>
</ng-template>
<ng-template #editExclusions let-modal>
	<div class="modal-header">
		<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"><i class="fa fa-close"></i></button>
	</div>
	<div class="modal-body text-dark">
		<h4> Exclusion Rules for {{editrule_name}}</h4>
		<div class="row">
			<div class="col-12">
				<table class="table table-striped">
					<tbody>
						<ng-container *ngIf="ruleset.length != 0">
							<tr *ngFor="let rule of ruleset;">
								<td> {{ rule.description }} </td>
								<td><button mat-stroked-button (click)="editRule(rule)"><mat-icon>edit</mat-icon></button><button mat-stroked-button (click)="deleteRule(rule)"><mat-icon>delete</mat-icon></button></td>
							</tr>
						</ng-container>
						<tr *ngIf="ruleset.length == 0">
							<td> No Rules Defined </td>
							<td></td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
		<form [formGroup]="exclusionForm">
			<div class="row">
				<div class="col-3">
					<mat-form-field appearance="outline">
						<mat-label>Rule Type</mat-label>
						<mat-select formControlName="rule_type" (selectionChange)="typechange()">
							<mat-option *ngFor="let k of ruletypes | keyvalue" [value]="k.key">{{k.value}}</mat-option>
						</mat-select>
					</mat-form-field>
				</div>

				<div class="col-3">
					<mat-form-field appearance="outline">
						<mat-label>Inclusive</mat-label>
						<mat-select formControlName="rule_inclusive">
							<mat-option value="0">Not Equal To</mat-option>
							<mat-option value="1">Equal To</mat-option>
						</mat-select>
					</mat-form-field>
				</div>
				<div class="col-3" *ngIf="editrule_type == 'P'">
					<mat-form-field appearance="outline">
						<mat-label>Product Line</mat-label>
						<mat-select formControlName="rule_value">
							<mat-option *ngFor="let k of prodlines" [value]="k.line_field">{{k.line_description}}</mat-option>
						</mat-select>
					</mat-form-field>
				</div>
				<div class="col-3" *ngIf="editrule_type == 'C'">
					<mat-form-field appearance="outline">
						<mat-label>Category</mat-label>
						<mat-select formControlName="rule_value">
							<mat-option *ngFor="let k of categories" [value]="k.categoryid">{{k.categorydescription}}</mat-option>
						</mat-select>
					</mat-form-field>
				</div>
				<div class="col-3" *ngIf="editrule_type == 'B'">
					<mat-form-field appearance="outline">
						<mat-label>Brand</mat-label>
						<mat-select formControlName="rule_value">
							<mat-option *ngFor="let k of brands" [value]="k.manufacturer_id">{{k.name}}</mat-option>
						</mat-select>
					</mat-form-field>
				</div>
				<div class="col-3" *ngIf="editrule_type == 'S'">
					<mat-form-field appearance="outline">
						<mat-label>Item Number</mat-label>
						<input matInput formControlName="rule_value" />
					</mat-form-field>
				</div>
				<div class="col-3">
					<button mat-stroked-button color="success" aria-label="" (click)="saveRule()" class="mt-2">
						<mat-icon>save</mat-icon> Save
					</button>
				</div>
			</div>
		</form>
	</div>

	<div class="modal-footer">
	</div>
</ng-template>
<ng-template #addVendor let-modal>
	<div class="modal-header">
		<h4 class="modal-title" id="modal-title">Edit</h4>
		<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"><i class="fa fa-close"></i></button>
	</div>
	<div class="modal-body text-dark">
		<div class="row">
			<div class="card">
				<div class="card-header text-center">
					<h4 class="card-title text-center"></h4>
				</div>
				<div class="card-body text-center">
					<div class="row">
						<div class="col-12">
							<form [formGroup]="vendorTypeForm">
								<mat-form-field appearance="outline">
									<mat-label>Vendor Type</mat-label>
									<input type="text" class="text-let m-0 p-0" matInput formControlName="typename" />
								</mat-form-field>
								<button mat-stroked-button color="success" aria-label="" (click)="addVendorType()" class="mt-2">
									<mat-icon>save</mat-icon> Save
								</button>
							</form>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="modal-footer">
	</div>
</ng-template>

<ng-template #addSalesTypeEle let-modal>
	<!-- Modal Header -->
	<div class="modal-header">
		<h5 class="modal-title">Add or Update Sales Type</h5>
		<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')">
			<i class="fa fa-times"></i>
		</button>
	</div>

	<div class="modal-body text-dark">

		<div class="row">
			<div class="col-12">
				<form [formGroup]="salesTypeForm">
					<div class="sales-type-form-container">
						<div class="form-card w-100">
							<div class="row mb-3">
								<!-- Sales Type -->
								<div class="col-md-4">
									<mat-form-field appearance="outline" class="w-100">
										<mat-label>Sales Type (Abbreviation)</mat-label>
										<input type="text" matInput formControlName="typeabbrev" placeholder="Enter Sales Type Abbreviation" />
									</mat-form-field>
								</div>

								<!-- Name -->
								<div class="col-md-4">
									<mat-form-field appearance="outline" class="w-100">
										<mat-label>Sales Type Name</mat-label>
										<input type="text" matInput formControlName="sales_type" placeholder="Enter Sales Type Name" />
									</mat-form-field>
								</div>

								<!-- Cost Multiplier -->
								<div class="col-md-4">
									<mat-form-field appearance="outline" class="w-100">
										<mat-label>Cost Multiplier</mat-label>
										<input type="number" matInput formControlName="costMultiplier" placeholder="Enter Cost Multiplier (e.g., 1.2)" />
									</mat-form-field>
								</div>
							</div>
							<div class="row mb-3">
								<!-- Loyalty Points -->
								<div class="col-md-3">
									<mat-form-field appearance="outline" class="w-100">
										<mat-label>Loyalty Points</mat-label>
										<input type="number" matInput formControlName="loyaltypoints" placeholder="Enter Loyalty Points" />
									</mat-form-field>
								</div>

								<!-- Price Book Toggle -->
								<div class="col-md-3">
									<mat-form-field appearance="outline" class="w-100">
										<mat-label>Price Book</mat-label>
										<mat-select formControlName="ispricebook">
											<mat-option [value]="'0'">No</mat-option>
											<mat-option [value]="'1'">Yes</mat-option>
										</mat-select>
									</mat-form-field>
								</div>
								<!-- Fall Back Level -->
								<div class="col-md-6">
									<mat-form-field appearance="outline" class="w-100">
										<mat-label>Fall Back Level</mat-label>
										<mat-select formControlName="fallback">
											<mat-option [value]="type.typeabbrev" *ngFor="let type of salestypes">
												{{ type.typeabbrev }} - {{ type.sales_type }}
											</mat-option>
										</mat-select>
									</mat-form-field>
								</div>

							</div>
							<div class="row">
								<!-- Table Name -->
								<div class="col-md-3" [ngClass]="(salesTypeForm.get('ispricebook') && salesTypeForm.get('ispricebook').value == '1') ? '' : 'd-none'">
									<mat-form-field appearance="outline" class="w-100">
										<mat-label>Table Name</mat-label>
										<input type="text" matInput formControlName="tablename" placeholder="Enter Table Name" />
									</mat-form-field>
								</div>
							</div>
						</div>
					</div>
				</form>
				<ng-container *ngIf="salesTypeForm.get('ispricebook') && salesTypeForm.get('ispricebook').value == '1'">
					<!-- Instructions Section -->
					<div class="pricebook-card">
						<div class="pricebook-card-header">
							How to Update the PriceBook
						</div>
						<div class="card-body">
							<ol>
								<li>
									<strong>Turn On "New PriceBook":</strong> Use the <em>New PriceBook</em> switch only if you're creating a new PriceBook table. Leave it off if you're adding to an existing PriceBook.
								</li>
								<li>
									<strong>Get Your File Ready:</strong> Make sure your file is a CSV/XLS/XLSX. Don’t worry—file names and column headers will be cleaned up automatically to remove invalid characters. These headers <code>brand</code>, <code>price</code>, and <code>partno</code>  are REQUIRED, AND REMOVE FORMULAS!.
								</li>
								<li>
									<strong>Upload the File:</strong> Drag and drop your file into the upload box or click to choose a file. You can only upload one file at a time.
								</li>
								<li>
									<strong>Match Your Data:</strong> After uploading, you’ll need to map your file's columns (e.g., <code>brand</code>, <code>partno</code>, <code>price</code>) to the required fields. This step ensures everything lines up correctly.
								</li>
								<li>
									<strong>Stock ID Matching:</strong> The system will automatically match <code>brand</code> and <code>partno</code> to find the right <code>stockid</code>. If needed, it will clean up the data and try again.
								</li>
								<li>
									<strong>Review and Save:</strong> Once your data is ready, check the preview table to make sure everything looks good. When you’re ready, click "Save" to save your PriceBook and update the Sales Type.
								</li>
							</ol>
						</div>

					</div>

					<!-- Toggle for New PriceBook -->
					<div class="form-group mb-4 mt-3">
						<mat-slide-toggle formControlName="newpricebook" class="d-flex align-items-center">
							<strong>Create New PriceBook</strong>
						</mat-slide-toggle>
					</div>

					<!-- File Upload Section -->
					<ng-container *ngIf="!uploaddata?.header && !isProcessing; else dataPreview">
						<div class="pricebook-card">
							<div class="card-body text-center">
								<ngx-dropzone class="pricebook-dropzone" [multiple]="false" (change)="onSelect($event)" required>
									<ngx-dropzone-label>
										Drop file here or click to upload
									</ngx-dropzone-label>
									<ngx-dropzone-preview *ngFor="let f of files" [removable]="true" (removed)="onRemove(f)" (error)="onUploadError($event)" (success)="onUploadSuccess($event)">
										<ngx-dropzone-label class="text-info">
											<strong>{{ f.name }}</strong> ({{ f.type }})
										</ngx-dropzone-label>
									</ngx-dropzone-preview>
								</ngx-dropzone>
							</div>
						</div>
					</ng-container>



					<!-- Data Preview and Mapping -->
					<ng-template #dataPreview>
						<div class="pricebook-card">
							<div class="pricebook-card-header">
								Data Preview for Table: <spna *ngIf="tablename">{{ tablename }}</spna>
							</div>
							<div class="card-body">
								<div class="text-center mb-4">
									<div *ngIf="!uploaddata || isProcessing">
										<mat-icon>cloud_upload</mat-icon>
										<!-- Spinner -->
										<div *ngIf="isProcessing" class="text-center pricebook-spinner ml-auto mr-auto">
											<mat-spinner></mat-spinner>
											<div class="ml-auto mr-auto pricebook-spinner-text">Processing your file, please wait...</div>
										</div>
									</div>
								</div>
								<div class="pricebook-table-responsive" *ngIf="uploaddata?.header">
									<table class="table table-bordered table-fixed">
										<!-- Headers -->
										<thead class="thead-dark sticky-header">
											<tr>
												<th *ngFor="let col of uploaddata.header">
													{{ col }}
												</th>
											</tr>
										</thead>
										<tbody>
											<!-- Mapping -->
											<tr>
												<td *ngFor="let col of uploaddata.header">
													<div class="custom-select-wrapper">
														<label class="select-label">Map Field</label>
														<select class="custom-select" [(ngModel)]="mapping[col]" required>
															<option *ngFor="let map of mapcols" [value]="map.field">
																{{ map.label }}
															</option>
														</select>
													</div>
												</td>
											</tr>
											<!-- Data Rows -->
											<tr *ngFor="let row of uploaddata.rows">
												<td *ngFor="let col of uploaddata.header">
													{{ row[col] }}
												</td>
											</tr>
										</tbody>
									</table>
								</div>

							</div>
						</div>
					</ng-template>
				</ng-container>
				<div class="row">
					<div class="col-12 text-right">
						<button
							class="btn btn-success mt-2"
							[disabled]="isSaving"
							(click)="addSalesType()">
							<span *ngIf="!isSaving">
								<i class="fa fa-save"></i> Save
							</span>
							<span *ngIf="isSaving">
								<i class="fa fa-spinner fa-spin"></i> Saving...
							</span>
						</button>
					</div>

				</div>
			</div>
		</div>
	</div>

	<div class="modal-footer">
	</div>
</ng-template>

<ng-template #addPaymentTermEle let-modal>
	<div class="modal-header">
		<h4 class="modal-title" id="modal-title">Payment Terms</h4>
		<button type="button" class="btn btn-sm btn-info me-2" (click)="openPaymentTermsHelp()" title="How Payment Terms Work">
			<i class="fa fa-question-circle"></i> Help
		</button>
		<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"><i class="fa fa-close"></i></button>
	</div>
	<div class="modal-body text-dark payment-terms-form-body">
		<form [formGroup]="paymentTermsForm" class="payment-terms-form">

			<!-- Basic Information -->
			<div class="form-section">
				<div class="row g-3">
					<div class="col-md-6">
						<mat-form-field appearance="outline" class="w-100">
							<mat-label>Code</mat-label>
							<input type="text" matInput formControlName="termsindicator" maxlength="4" />
							<mat-hint>4 characters max (e.g., N30, COD)</mat-hint>
							<mat-error *ngIf="paymentTermsForm.get('termsindicator').hasError('required')">Required</mat-error>
						</mat-form-field>
					</div>
					<div class="col-md-6">
						<mat-form-field appearance="outline" class="w-100">
							<mat-label>Name</mat-label>
							<input type="text" matInput formControlName="terms" />
							<mat-hint>Display name for this payment term</mat-hint>
							<mat-error *ngIf="paymentTermsForm.get('terms').hasError('required')">Required</mat-error>
						</mat-form-field>
					</div>
				</div>
			</div>

			<!-- Due Date Type Selection -->
			<div class="form-section">
				<label class="section-label">When is payment due?</label>
				<div class="row g-3 align-items-end">
					<div class="col-md-8">
						<mat-radio-group formControlName="dueDateType" class="radio-group" (change)="onDueDateTypeChange()">
							<mat-radio-button value="days" class="radio-option">
								X days after invoice
							</mat-radio-button>
							<mat-radio-button value="dayOfMonth" class="radio-option">
								On day X of month
							</mat-radio-button>
							<mat-radio-button value="endOfMonth" class="radio-option">
								Last day of month
							</mat-radio-button>
						</mat-radio-group>
					</div>
					<div class="col-md-4" *ngIf="paymentTermsForm.get('dueDateType').value === 'days'">
						<mat-form-field appearance="outline" class="w-100">
							<mat-label>Days</mat-label>
							<input type="number" min="0" matInput formControlName="daysbeforedue" (keyup)="getExampleDueDate()"/>
							<mat-hint>Add this many days to invoice date</mat-hint>
						</mat-form-field>
					</div>
					<div class="col-md-4" *ngIf="paymentTermsForm.get('dueDateType').value === 'dayOfMonth'">
						<mat-form-field appearance="outline" class="w-100">
							<mat-label>Day</mat-label>
							<input type="number" min="1" max="31" matInput formControlName="dayinfollowingmonth" (keyup)="getExampleDueDate()"/>
							<mat-hint>Set due date to this day (31 = last day of month)</mat-hint>
						</mat-form-field>
					</div>
				</div>
				<div class="row g-3 mt-3">
					<div class="col-md-6">
						<mat-form-field appearance="outline" class="w-100">
							<mat-label>Period Start Day</mat-label>
							<input type="number" min="1" max="31" matInput formControlName="agefrom" (keyup)="getExampleDueDate()"/>
							<mat-hint>Reserved for future use (default: 1)</mat-hint>
						</mat-form-field>
					</div>
					<div class="col-md-6">
						<mat-form-field appearance="outline" class="w-100">
							<mat-label>Month Rollover Threshold</mat-label>
							<input type="number" min="1" max="31" matInput formControlName="ageto" (keyup)="getExampleDueDate()"/>
							<mat-hint>If invoice day > this, move to next month first (default: 25, 31 = last day)</mat-hint>
						</mat-form-field>
					</div>
				</div>
			</div>

			<!-- Due Date Calculator Preview -->
			<div class="form-section calculator-section">
				<label class="section-label">Preview Due Date</label>
				<div class="calculator-box">
					<div class="row g-3 align-items-center">
						<div class="col-md-5">
							<mat-form-field appearance="outline" class="w-100">
								<mat-label>Invoice Date</mat-label>
								<input matInput [matDatepicker]="picker" [formControl]="exampleTranDate" (click)="picker.open()">
								<mat-datepicker-toggle matSuffix [for]="picker">
									<mat-icon matDatepickerToggleIcon>calendar_today</mat-icon>
								</mat-datepicker-toggle>
								<mat-datepicker #picker></mat-datepicker>
							</mat-form-field>
						</div>
						<div class="col-md-2 text-center">
							<span class="arrow-icon">→</span>
						</div>
						<div class="col-md-5">
							<div class="due-date-display">
								<div *ngIf="calculatingDue" class="text-center py-2">
									<mat-spinner diameter="24"></mat-spinner>
								</div>
								<div *ngIf="!calculatingDue && duedate" class="due-date-result">
									{{duedate}}
								</div>
								<div *ngIf="!calculatingDue && !duedate" class="text-muted text-center py-2">
									Select a date
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<!-- Advanced Options: Statement Periods -->
			<div class="form-section advanced-section">
				<label class="section-label">Advanced Options</label>
				<div class="advanced-info">
					<small class="text-muted">Statement period settings</small>
				</div>
				<div class="row g-3 mt-2">
					<div class="col-md-6">
						<mat-form-field appearance="outline" class="w-100">
							<mat-label>Statement Periods</mat-label>
							<input type="number" min="0" matInput formControlName="statementperiods" (keyup)="getExampleDueDate()"/>
							<mat-hint>Wait this many periods (each = next month + ~24 days)</mat-hint>
							<mat-error *ngIf="paymentTermsForm.get('statementperiods').hasError('required')">Required</mat-error>
						</mat-form-field>
					</div>
				</div>
			</div>

			<!-- Optional: Early Payment Discount -->
			<div class="form-section">
				<div class="row g-3">
					<div class="col-md-6">
						<mat-form-field appearance="outline" class="w-100">
							<mat-label>Early Payment Discount (%)</mat-label>
							<input type="number" step="0.01" min="0" matInput formControlName="terms_discount" />
							<mat-hint>Optional (e.g., 2% for 2/10 Net 30)</mat-hint>
						</mat-form-field>
					</div>
					<div class="col-md-6">
						<mat-form-field appearance="outline" class="w-100">
							<mat-label>Number of Payments</mat-label>
							<input type="number" min="1" matInput formControlName="numpayments" />
							<mat-hint>Installments (default: 1)</mat-hint>
						</mat-form-field>
					</div>
				</div>
			</div>

			<!-- Payment Options -->
			<div class="form-section">
				<label class="section-label">Payment Options</label>
				<div class="checkbox-group">
					<div class="checkbox-row">
						<mat-checkbox [checked]="paymentTermsForm.get('collect_payment').value === '1'"
									  (change)="paymentTermsForm.get('collect_payment').setValue($event.checked ? '1' : '0')">
							Collect payment on order
						</mat-checkbox>
					</div>
					<div class="checkbox-row">
						<mat-checkbox [checked]="paymentTermsForm.get('onaccountallowed').value === '1'"
									  (change)="paymentTermsForm.get('onaccountallowed').setValue($event.checked ? '1' : '0')">
							Allow on account
						</mat-checkbox>
					</div>
					<div class="checkbox-row">
						<mat-checkbox [checked]="paymentTermsForm.get('order_entry').value === '1'"
									  (change)="paymentTermsForm.get('order_entry').setValue($event.checked ? '1' : '0')">
							Show in order entry
						</mat-checkbox>
					</div>
					<div class="checkbox-row">
						<mat-checkbox [checked]="paymentTermsForm.get('cc_process').value === '1'"
									  (change)="paymentTermsForm.get('cc_process').setValue($event.checked ? '1' : '0')">
							Require credit card
						</mat-checkbox>
					</div>
					<div class="checkbox-row">
						<mat-checkbox [checked]="paymentTermsForm.get('decline').value === '1'"
									  (change)="paymentTermsForm.get('decline').setValue($event.checked ? '1' : '0')">
							Allow card decline
						</mat-checkbox>
					</div>
					<div class="checkbox-row">
						<mat-checkbox [checked]="paymentTermsForm.get('donot_print').value === '1'"
									  (change)="paymentTermsForm.get('donot_print').setValue($event.checked ? '1' : '0')">
							Don't print on documents
						</mat-checkbox>
					</div>
				</div>
			</div>

			<!-- Actions -->
			<div class="form-actions">
				<button mat-stroked-button (click)="modal.dismiss()" class="me-2">Cancel</button>
				<button mat-raised-button color="primary" (click)="addPaymentTerm()" [disabled]="!paymentTermsForm.valid">
					Save
				</button>
			</div>
		</form>
	</div>
	<div class="modal-footer">
	</div>
</ng-template>

<ng-template #paymentTermsHelp let-modal>
	<div class="modal-header">
		<h4 class="modal-title" id="modal-title">Payment Terms - How It Works</h4>
		<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"><i class="fa fa-close"></i></button>
	</div>
	<div class="modal-body text-dark">
		<div class="row">
			<div class="col-12">
				<div class="card mb-3">
					<div class="card-header bg-primary text-white">
						<h6 class="mb-0"><i class="fa fa-calendar"></i> Due Date Configuration Fields</h6>
					</div>
					<div class="card-body text-dark">
						<div class="mb-3">
							<strong>Days:</strong>
							<p class="mb-0">Adds this many days to the invoice date. If "Day" is also set, days are added first, then the due date is set to the specified day of month.</p>
							<small class="text-muted">Example: 30 = Invoice date + 30 days (Net 30)</small>
						</div>

						<div class="mb-3">
							<strong>Day:</strong>
							<p class="mb-0">Sets the final due date to this day of the month (1-31). This happens after all other calculations (statement periods, days added, month rollovers). If set to 31, it means the last day of the month.</p>
							<small class="text-muted">Example: 10 = Due date will be the 10th of the calculated month</small>
						</div>

						<div class="mb-3">
							<strong>Statement Periods:</strong>
							<p class="mb-0">Number of statement periods to wait before calculating the due date. Each period: moves to the 1st of next month, then adds approximately 24 days (statement run day - 1). If the invoice date is after the statement run day, one extra period is added automatically.</p>
							<small class="text-muted">Example: 1 = Move to next month's 1st, add ~24 days, then continue calculation</small>
						</div>

						<div class="mb-3">
							<strong>Period Start Day:</strong>
							<p class="mb-0">Currently reserved for future use and does not affect due date calculations. Default value is 1.</p>
							<small class="text-muted">Note: This field is stored but not currently used in calculations</small>
						</div>

						<div class="mb-3">
							<strong>Month Rollover Threshold:</strong>
							<p class="mb-0">If the invoice day is greater than this value, the transaction is moved to the 1st of the next month BEFORE other calculations. This happens first, before statement periods or days are added. If set to 31, it means the last day of the month.</p>
							<small class="text-muted">Example: If set to 25, an invoice on the 26th is moved to the 1st of next month before calculating due date</small>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="modal-footer">
	</div>
</ng-template>

<ng-template #addClubEle let-modal>
	<div class="modal-header">
		<h4 class="modal-title" id="modal-title">Club</h4>
		<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"><i class="fa fa-close"></i></button>
	</div>
	<div class="modal-body text-dark">
		<div class="row">
			<div class="col-12">
				<form [formGroup]="clubForm">
					<mat-form-field appearance="outline" class="w-100">
						<mat-label>Club Name</mat-label>
						<input type="text" matInput formControlName="club" />
					</mat-form-field>
					<div class="text-end mt-3">
						<button mat-stroked-button (click)="modal.dismiss()" class="me-2">Cancel</button>
						<button mat-raised-button color="primary" (click)="addClub()" [disabled]="!clubForm.valid">Save</button>
					</div>
				</form>
			</div>
		</div>
	</div>
	<div class="modal-footer">
	</div>
</ng-template>

<ng-template #addClubEle let-modal>
	<div class="modal-header">
		<h4 class="modal-title" id="modal-title">Club</h4>
		<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"><i class="fa fa-close"></i></button>
	</div>
	<div class="modal-body text-dark">
		<div class="row">
			<div class="card">
				<div class="card-header text-center">
					<h4 class="card-title text-center"></h4>
				</div>
				<div class="card-body text-center">
					<div class="row">

						<form [formGroup]="clubForm" class="container">
							<div class="row">
								<div class="col-md-6 mb-3">
									<mat-form-field appearance="outline" class="w-100">
										<mat-label>Name</mat-label>
										<input type="text" class="text-let m-0 p-0" matInput formControlName="club" />
									</mat-form-field>
								</div>
							</div>

							<div class="row">
								<div class="col-12 text-center">
									<button mat-stroked-button color="success" aria-label="" (click)="addClub()" class="mt-2">
										<mat-icon>save</mat-icon> Save
									</button>
								</div>
							</div>
						</form>


					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="modal-footer">
	</div>
</ng-template>
<div class="main-content">
	<div class="container-fluid">
		<div class="row">
			<div class="col-md-12">
				<div class="card">
					<div class="card-header card-header-{{color}}-5">
						<h4 class="card-title "><i class="material-icons" (click)="back()">arrow_left</i> System Types</h4>
						<p class="card-category text-right">System Types</p>
					</div>
					<div class="card-body">
						<mat-tab-group #tabPanel mat-align-tabs="start" class="" color="accent">
							<mat-tab label="Sales Types">
								<button mat-stroked-button color="success" aria-label="" (click)="addSalesTypeDisplay()" class="mt-2">
									<mat-icon>add</mat-icon> Add Sales Type
								</button>

								<mat-progress-bar mode="indeterminate" color="accent" *ngIf="isLoading"></mat-progress-bar>

								<table class="table table-sm mt-3">
									<tr>
										<th></th>
										<th>Abbreviation</th>
										<th>Type</th>
										<th>Cost x</th>
										<th>Loyalty Points</th>
										<th>Price Book</th>
									</tr>
									<tr *ngFor="let type of salestypes">
										<td>
											<button mat-icon-button color="warn" aria-label="delete" class="small-font" (click)="removeSalesType(type)">
												<mat-icon>remove</mat-icon>
											</button>
											<button mat-icon-button color="accent" aria-label="Edit" class="small-font" (click)="editSalesTypeDispaly(type)">
												<mat-icon>edit</mat-icon>
											</button>
										</td>
										<td>{{ type.typeabbrev }}</td>
										<td>{{ type.sales_type }}</td>
										<td>{{ type.costMultiplier }}</td>
										<td>{{ type.loyaltypoints }}</td>
										<td>{{ yesNoValue(type.ispricebook) }}</td>
									</tr>
								</table>
							</mat-tab>
							<mat-tab label="Payment Types">
								<app-payment-types></app-payment-types>
							</mat-tab>
							<mat-tab label="Payment Terms">
								<div class="row mb-3 mt-3">
									<div class="col-md-6">
										<button mat-stroked-button color="success" aria-label="" (click)="addPaymentTermView()" class="mt-2">
											<mat-icon>add</mat-icon> Add Payment Term
										</button>
									</div>
									<div class="col-md-3">
										<mat-form-field appearance="outline" class="w-100">
											<mat-label>Search</mat-label>
											<input matInput [(ngModel)]="paymentTermsSearchFilter" placeholder="Search by code or name">
											<mat-icon matPrefix>search</mat-icon>
										</mat-form-field>
									</div>
								</div>
								<mat-progress-bar mode="indeterminate" color="accent" *ngIf="isLoading"></mat-progress-bar>
								<div class="table-responsive">
									<table class="table table-sm mt-3">
										<thead>
											<tr>
												<th>Actions</th>
												<th>Code</th>
												<th>Name</th>
												<th>Description</th>
												<th>Days After Invoice</th>
												<th>Due Day of Month</th>
												<th>Statement Periods</th>
												<th>Discount %</th>
												<th>Payments</th>
												<th>Require CC</th>
												<th>Collect Payment</th>
												<th>On Account</th>
											</tr>
										</thead>
										<tbody>
											<tr *ngFor="let type of getFilteredPaymentTerms()">
												<td>
													<button mat-icon-button color="warn" aria-label="delete" class="small-font" (click)="removePaymentTerm(type)">
														<mat-icon>remove</mat-icon>
													</button>
													<button mat-icon-button color="accent" aria-label="Edit" class="small-font" (click)="editPaymentTermDispaly(type)">
														<mat-icon>edit</mat-icon>
													</button>
												</td>
												<td><strong>{{ type.termsindicator }}</strong></td>
												<td>{{ type.terms }}</td>
												<td>
													<small class="text-muted">{{ getPaymentTermDescription(type) }}</small>
												</td>
												<td>{{ type.daysbeforedue || '-' }}</td>
												<td>{{ type.dayinfollowingmonth || '-' }}</td>
												<td>{{ type.statementperiods || '-' }}</td>
												<td>{{ type.terms_discount || '0.00' }}%</td>
												<td>{{ type.numpayments || '1' }}</td>
												<td>{{ yesNoValue(type.cc_process) }}</td>
												<td>{{ yesNoValue(type.collect_payment) }}</td>
												<td>{{ yesNoValue(type.onaccountallowed) }}</td>
											</tr>
											<tr *ngIf="getFilteredPaymentTerms().length === 0">
												<td colspan="12" class="text-center text-muted">
													No payment terms found matching your search criteria.
												</td>
											</tr>
										</tbody>
									</table>
								</div>
							</mat-tab>
							<mat-tab label="Customer Types">
								<button mat-stroked-button color="success" aria-label="" (click)="addCustomerTypeView()" class="mt-2">
									<mat-icon>add</mat-icon> Add Customer Type
								</button>
								<mat-progress-bar mode="indeterminate" color="accent" *ngIf="isLoading"></mat-progress-bar>
								<table class="table table-sm mt-3">
									<tr>
										<th></th>
										<th>ID</th>
										<th>Name</th>
										<th></th>
									</tr>
									<tr *ngFor="let type of customertypes">
										<td>
											<button mat-icon-button color="warn" aria-label="delete" class="small-font" (click)="removeCustomerType(type)">
												<mat-icon>remove</mat-icon>
											</button>
											<button mat-icon-button color="accent" aria-label="Edit" class="small-font" (click)="editCustomerTypeDisplay(type)">
												<mat-icon>edit</mat-icon>
											</button>
										</td>
										<td>{{ type.typeid }}</td>
										<td>{{ type.typename }}</td>
										<td><button mat-icon-button color="accent" aria-label="Edit" class="small-font" (click)="editCustomerTypeExclusions(type)">
												<mat-icon>block</mat-icon> Product Exclusions
											</button></td>
									</tr>
								</table>
							</mat-tab>
							<mat-tab label="Vendor Types">
								<button mat-stroked-button color="success" aria-label="" (click)="addVendorTypeDisplay()" class="mt-2">
									<mat-icon>add</mat-icon> Add Vendor Type
								</button>

								<mat-progress-bar mode="indeterminate" color="accent" *ngIf="isLoading"></mat-progress-bar>

								<table class="table table-sm mt-3">
									<tr>
										<th></th>
										<th>ID</th>
										<th>Name</th>
										<th></th>
									</tr>
									<tr *ngFor="let type of supptypes">
										<td>
											<button mat-icon-button color="warn" aria-label="delete" class="small-font" (click)="removeVendorType(type)">
												<mat-icon>remove</mat-icon>
											</button>
											<button mat-icon-button color="accent" aria-label="Edit" class="small-font" (click)="editVendorTypeDisplay(type)">
												<mat-icon>edit</mat-icon>
											</button>
										</td>
										<td>{{ type.typeid }}</td>
										<td>{{ type.typename }}</td>
										<td></td>
									</tr>
								</table>
							</mat-tab>
							<mat-tab label="Contact Types">
							  <button mat-stroked-button color="success" aria-label="" (click)="addContactTypeDisplay()" class="mt-2">
								<mat-icon>add</mat-icon> Add Contact Type
							  </button>

							  <mat-progress-bar mode="indeterminate" color="accent" *ngIf="isLoading"></mat-progress-bar>

							  <table class="table table-sm mt-3">
								<thead>
								  <tr>
									<th>Actions</th>
									<th>Type</th>
									<th>Role</th>
								  </tr>
								</thead>
								<tbody>
								  <tr *ngFor="let type of contacttypes">
									<td>
										<button mat-icon-button color="warn" aria-label="delete" class="small-font"
											(click)="removeContactType(type)"
											[disabled]="protectedRoles.includes(type.contact_role?.toUpperCase())">
											<mat-icon>remove</mat-icon>
										</button>
										<button mat-icon-button color="accent" aria-label="edit" class="small-font"
											(click)="editContactTypeDisplay(type)">
											<mat-icon>edit</mat-icon>
										</button>
									</td>

									<td>{{ type.contact_type }}</td>
									<td>{{ type.contact_role }}</td>
								  </tr>
								</tbody>
							  </table>
							</mat-tab>

							<mat-tab label="Clubs">
								<button mat-stroked-button color="success" aria-label="" (click)="addClubDisplay()" class="mt-2">
									<mat-icon>add</mat-icon> Add Club
								</button>

								<mat-progress-bar mode="indeterminate" color="accent" *ngIf="isLoading"></mat-progress-bar>

								<table class="table table-sm mt-3">
									<tr>
										<th></th>
										<th>ID</th>
										<th>Name</th>
										<th></th>
									</tr>
									<tr *ngFor="let type of clubs">
										<td>
											<button mat-icon-button color="warn" aria-label="delete" class="small-font" (click)="removeClub(type)">
												<mat-icon>remove</mat-icon>
											</button>
											<button mat-icon-button color="accent" aria-label="Edit" class="small-font" (click)="editClubDisplay(type)">
												<mat-icon>edit</mat-icon>
											</button>
										</td>
										<td>{{ type.id }}</td>
										<td>{{ type.club }}</td>
										<td></td>
									</tr>
								</table>
							</mat-tab>
						</mat-tab-group>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>